import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  constructor(private router: Router) { }

  currentUser: any;

  getToken(): string | null {
    const token = sessionStorage.getItem('JWT_TOKEN');
    if (token != null && !this.isTokenExpired(token)) {
      this.currentUser = token;
      return token;
    }else{
      return null
    }
    // else return false;

  }

  getRoles(): string {
    const token = sessionStorage.getItem('JWT_TOKEN');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).sub.role;
    }
    else return 'All';
  }

  saveToken(token: String) {
    sessionStorage['JWT_TOKEN'] = token;
  }

  destroyToken() {
    sessionStorage.removeItem('JWT_TOKEN');
  }
  public urlBase64Decode(str: string): string {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0: { break; }
      case 2: { output += '=='; break; }
      case 3: { output += '='; break; }
      default: {
        throw 'Illegal base64url string!';
      }
    }
    return this.b64DecodeUnicode(output);
  }


  private b64decode(str: string): string {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output: string = '';

    str = String(str).replace(/=+$/, '');

    if (str.length % 4 == 1) {
      throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    }

    for (
      // initialize result and counters
      let bc: number = 0, bs: any, buffer: any, idx: number = 0;
      // get next character
      buffer = str.charAt(idx++);
      // character found in table? initialize bit storage and add its ascii value;
      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
        // and if not first of each 4 characters,
        // convert the first 8 bits to one ascii character
        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
    ) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }
    return output;
  }

  // https://developer.mozilla.org/en/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
  private b64DecodeUnicode(str: any) {
    return decodeURIComponent(Array.prototype.map.call(this.b64decode(str), (c: any) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  public decodeToken(token: String): any {
    let parts = token.split('.');

    if (parts.length !== 3) {
      throw new Error('JWT must have 3 parts');
    }

    let decoded = this.urlBase64Decode(parts[1]);
    if (!decoded) {
      throw new Error('Cannot decode the token');
    }

    return JSON.parse(decoded);
  }

  public getTokenExpirationDate(token: String): Date | null {
    let decoded: any;
    decoded = this.decodeToken(token);
    if (!decoded.hasOwnProperty('exp')) {
      return null;
    }

    let date = new Date(0); // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  public isTokenExpired(token: String, offsetSeconds?: number): boolean {
    let date = this.getTokenExpirationDate(token);
    offsetSeconds = offsetSeconds || 0;

    if (date == null) {
      return false;
    }

    // Token expired?
    return !(date.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
  }

  checkSessionTimeout(): boolean {
    const token = sessionStorage.getItem('JWT_TOKEN');

    if (token != null && !this.isTokenExpired(token)) {
      return true;
    }
    else {
      return false
    }
  }

  getUserFullName(){
    const token = sessionStorage.getItem('JWT_TOKEN');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).FullName;
    }
    else {
      return ""
    };
  }

  getUserId(){
    const token = sessionStorage.getItem('JWT_TOKEN');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).UserId;
    }
    else {
      return 0
    };
  }

  getRole(){
    const token = sessionStorage.getItem('JWT_TOKEN');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).Role;
    }
    else {
      return ""
    };
  }

  getSessionId(){
    const token = sessionStorage.getItem('JWT_TOKEN');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).SessionIDs;
    }
    else {
      return ""
    };
  }

  getUserName(){
    const token = sessionStorage.getItem('JWT_TOKEN');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).UserName;
    }
    else {
      return ""
    };
  }

  logout(){
    this.destroyToken();
    this.router.navigate(['/auth/login'])
  }
}
